

/**
 * Image Lazy loading module
 * 
 */

/* eslint-enable */

/**
 * This takes the data-src attribute and populates the image src
 * 
 * @param {Element} image 
 */
const loadImage = function(image) {
  const source = image.getAttribute('data-src');
  image.src = source;

  image.onload = function() {
    triggerResize();
  };
};


/**
 * This forces a resize event on the window
 * 
 * resize event helps with spacing issues
 */
const triggerResize = function() {
  if (navigator.userAgent.indexOf('MSIE') !== -1 ||
    navigator.appVersion.indexOf('Trident/') > 0) {
    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  } else {
    window.dispatchEvent(new Event('resize'));
  }
};

/**
 * 
 * @param {Element} element 
 */
const loadBackground = function(element) {
  const source = element.getAttribute('data-src');
  element.style.backgroundImage = `url('${source}')`;
};

/**
 * 
 * create config object: rootMargin and threshold
 * are two properties exposed by the interface
 */
export const config = {
  rootMargin: '0px 0px 100px 0px',
  threshold: 0,
};


/**
 * 
 * register the config object with an instance
 * of intersectionObserver
 */
const observer = new IntersectionObserver(function(entries, self) {
  // iterate over each entry
  entries.forEach(function(entry) {
    // process just the images that are intersecting.
    // isIntersecting is a property exposed by the interface
    if (entry.isIntersecting) {
      // custom function that copies the path to the img
      // from data-src to src
      if (entry.target.tagName === 'IMG') {
        loadImage(entry.target);
      } else if (entry.target.tagName === 'IFRAME') {
        loadImage(entry.target);
      } else {
        loadBackground(entry.target);
      }
      // the image is now in place, stop watching
      self.unobserve(entry.target);
    }
  });
}, config);

/**
 * Initialise the lazy load module
 *
 * @param {string} selector
 */
export default function(selector = '.lazyload[data-src]') {
  const imgs = document.querySelectorAll(selector);
  imgs.forEach(function(img) {
    observer.observe(img);
  });
}

/* global YT */

// var tag = document.createElement('script')
// tag.id = 'iframe-demo'
// tag.src = 'https://www.youtube.com/iframe_api'
// var firstScriptTag = document.getElementsByTagName('script')[0]
// firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

// function onYouTubeIframeAPIReady () {
//   addClickListeners()
// }

// function onPlayerReady (event) {
//   event.target.playVideo()
// }

// function makeHash (str) {
//   var hash = 0
//   var i
//   var chr
//   if (str === 0) return hash
//   for (i = 0; i < str.length; i++) {
//     chr = str.charCodeAt(i)
//     hash = ((hash << 5) - hash) + chr
//     hash |= 0 // Convert to 32bit integer
//   }
//   return Math.abs(hash)
// };

// function addClickListeners () {
//   var els = document.querySelectorAll('[data-youtube-id]')
//   els.forEach(function (el) {
//     el.addEventListener('click', function (e) {
//       e.preventDefault()

//       var t = e.target
//       var ytId = t.getAttribute('data-youtube-id')

//       window['player' + makeHash(ytId)] = new YT.Player(ytId, {
//         height: '390',
//         width: '640',
//         videoId: ytId,
//         events: {
//           'onReady': onPlayerReady
//         },
//         playerVars: {
//           'rel': 0
//         }
//       })

//       e.target.parentNode.classList.remove('youtube-thumb')
//     })
//   })
// }
